import * as types from '../constants/dashboardConstants';
import * as authTypes from '../redux/modules/auth';
import moment from 'moment';
let flagCheck =true;
// Auth
export function isLoaded(globalState) {
  return globalState.auth && globalState.auth.loaded;
}

export function showLoadingIndicator() {
  return {type: types.LOADING_ON};
}

export function updateCanLogout(){
  return {type: types.UPDATE_CAN_LOGOUT };
}

export function stopLoadingIndicator() {
  return {type: types.LOADING_OFF};
}

// Get Widget layout on dashboard initially
export function isThemeLoaded(globalState) {
  return globalState.dashboardRoot.dashboard && globalState.dashboardRoot.dashboard.loaded;
}

export function loadWidgetTheme() {
  return {
    type: types.LOAD_WIDGET,
    promise: (client) => client.post('/ScrTemplateDetail', {data: {
      UT:"trader",
      M:"L"
    }})
  };
}
export function getTempList() {
  return {
    type: types.LOAD_TEMPLIST, 
    promise: (client) => client.post('/ScrTemplateDetail',
    {data: {
      UT:"trader",
      M:"S"
    }})
  };
}
// Change dashboard to edit mode
export function editDashboard(clickedEdit) {
  return {type: types.EDIT_DASHBOARD, clickedEdit};
}
//save settings
export function saveSettings(DefaultACCod,isTrdInstant,storetradeqty,showStockPrc,isMarginWithOrders,fontSize,langCode,selectedTheme) {
  const obj={}
  obj.AC=DefaultACCod;
  obj.LN=langCode;
  obj.trdSettings={"isTrdInstant":isTrdInstant,"isDetailedInstList":"1","storetradeqty":storetradeqty,"showStock":showStockPrc,"isMarginWithOrders":isMarginWithOrders,"fontSize":fontSize,"selectedTheme":selectedTheme}
  return {
      type: authTypes.SAVE_SETTING,
      obj,
      promise: (client) => client.post('/saveTrdSettings', {
         data: obj
      })
    };
}
// Changing the layout of widgets
export function changeWidgetlayout(dashboardlayout, layout, deleteWidgetKey,flag) {
  //if(flagCheck===true){
   layout.map((item) => {
      let str = item.i;
      let id=item.i;
      str = str.substring(0, str.indexOf('-'));
      if(str==="Trade" || str==="TradeActivityBook" || str==="Chart"){
        dashboardlayout.map((item1) => {
          let str1 = item1.i;
          str1 = str1.substring(0, str1.indexOf('-'));
          if(str1==="Trade" && item1.i===id){
              item.cmdtyPair=item1.cmdtyPair;
          }
          if(item.name==="Chart" && item1.i===id){
            item.w=item1.w;
            item.h=item1.h;
            item.chartData=item1.chartData;
            item.cmdtyPair=item1.cmdtyPair;
          }
          if(item.name==="TradeActivityBook" && item1.i===id){
            item.w=item1.w;
            item.h=item1.h;
          }
        })
      }
    });
    if (deleteWidgetKey) {
      deleteWidgetKey.forEach((item) => {
        layout.forEach((element, index) => {
          if (item === element.i) {
            layout.splice(index, 1);
          }
        });
      });
    }
    // if(flag==="TRADE"){
    //   flagCheck=false;
    //   setTimeout(function() {
    //     flagCheck=true;
    //   }.bind(this), 5000);
    // }
  return {type: types.SUCCESS_CHANGE_WIDGETS, layout, deleteWidgetKey};
//}
}

//Set Default commodity
export function defaultComdtyPair(layout, cmdtyPair){
  return {type: types.DEFAULT_COMMODITYPAIR, layout, cmdtyPair};
}
// Save user changes on widgets
export function saveTemplate(layout,tradeBookColumns, tempName,tempCode, isDefault,mode) {
  if(tradeBookColumns.lmtOutStandingOrderColumnOrder[0] === 'action'){
    tradeBookColumns.lmtOutStandingOrderColumnOrder.shift();
  }
  if(tradeBookColumns.lmtOrderColumnOrder[0] === 'action'){
    tradeBookColumns.lmtOrderColumnOrder.shift();
  }
  const tempData ={"tmplData":layout,"tradeBookData":tradeBookColumns};
  const randomNo=Math.floor((Math.random() * 10) + 1);
  return {
    type: types.SAVE_WIDGET_ACTIONS, 
    promise: (client) => client.post('/ScrTemplateDetail', {
      data: {
        UT:"trader",
        M:mode,
        DF:isDefault,
        C: tempCode,
        N:tempName,
        D:tempData
      }
    }),
    layout,randomNo
   };
}

// Delete widgets in dashboard
export function deleteWidget(keyValue) {
    return {type: types.SUCCESS_DELETION, keyValue};
}

// Add widget to dashboard
export function addWidget(widget, layoutAdd) {
  return {type: types.ADD_SAMPLE_WIDGET, widget, layoutAdd};
}

// Commodity selection in trade panel
export function cmdtySelection(isCmdtySelected) {
  return {type: types.IS_CMDTY_SELECTED, isCmdtySelected};
}

// Hide popup
export function hidePopup() {
  return {type: types.HIDE_POPOUT};
}
export function layoutChanged(layoutCount) {
  return {type: types.LAYOUT_CHANGE_STATUS, layoutCount};
}
//update tradeBook Columns
export function updateTrdBookCols(updatedTrdCols){
  return {type: types.UPDATE_TRADEBOOK_COLUMNS, updatedTrdCols};
}

//setting modal
export function handleSettingModal(status) {
  return {
    type: types.HANDLE_SETTING_MODAL,
    status
  };
}


export function loadTemplate(tmpldata){
  const layout = JSON.parse(tmpldata);

  return {type: types.LOAD_TEMPLATE, layout};
}
export function handlebenchmarkModal(BMpopup) {
  return {
    type: types.HANDLE_BM_MODAL,
    BMpopup
  };
}
export function handleLimitModal(LMTPopup) {
  return {
    type: types.HANDLE_LMT_MODAL,
    LMTPopup
  };
}
export function addWidgetmodalflag(addWidgetFlag) {
  return {
    type: types.CHANGE_ADDWIDGETFLAG,
    addWidgetFlag
  };
}
export function layoutflag(status) {
  return {
    type: types.HANDLE_LAYOUT_FLAGMODAL,
    status
  };
}
export function loadTemplateFlag(flag){
  return {
    type: types.LOAD_TEMP_FLAG,
     flag
   };
}
// For changing commodity pair
export function changeCmdyPair(cmdyPair, currentId, layout,key) {
  return {
    type: types.CHANGE_COMMDTY,
    cmdyPair,
    currentId,
    layout,
    key,
  };
}
export function changeChartCmdyPair(cmdyPair, currentId, layout,template) {
  return {
    type: types.CHANGE_CHART_COMMDTY,
    cmdyPair,
    currentId,
    layout,
    template,
  };
}
export function setTooltipFlag(flag) {
  return {
    type: types.ENABLE_TOOLTIP,
    flag
  };
}
export function updateAccBal(acccode){
 return{
   type: types.LOAD_ACCOUNT,
   promise: (client) => client.get(`/loadAccount?acccode=${acccode}`)
 };
}
export function resizeMargin(height,width){
  return {
    type: types.MARGIN_LAYOUT,
     height,
     width
   };
}
export function resizeChart(height,width,key){
  return {
    type: types.CHART_LAYOUT,
     height,
     width,
     key
   };
}
export function resizeInstrumentList(height,width){
  return {
    type: types.INSTRUMENT_LAYOUT,
     height,
     width
   };
}
export function resizeTradebook(height,width,key){
  return {
    type: types.TRADEBOOK_LAYOUT,
     height,
     width,
     key
   };
}
export function resizeTradePanel(height,width,key){
  return {
    type: types.TRADEPANEL_LAYOUT,
     height,
     width,
     key
   };
}
export function closedLmtModal(flag,keyValue){
  return {
    type: types.CLOSE_LMT_MODAL,
     flag,
     keyValue
   };
}

export function setLogoutFlag(logoutFlag){
  return {
    type: types.CHANGE_LOGOUT_FLAG,
     logoutFlag
   };
}
export function loadLanguages(){
  return{
    type:  types.LOAD_LANGUAGES,
    promise: (client) => client.get('/getLanguages')
  };
}
export function setLayoutFlag(layoutModal){
  return {
    type: types.OPEN_LAYOUTMODAL_FLAG,
     layoutModal,
   };
}
export function setShowProfileFlag(showProfileFlag){
  return {
    type: types.SHOW_PROFILE_FLAG,
     showProfileFlag,
   };
}
export function tradeCnt(count){
  return {
    type: types.TRADE_WIDGET_COUNT,
     count,
   };
}
export function deleteLayout(tempCode,tempName,mode) {
  return {
    type: types.DELETE_LAYOUT, 
    promise: (client) => client.post('/ScrTemplateDetail', {
      data: {
        UT:"trader",
        M:mode,
        C: tempCode,
        N:tempName,
      }
    }),
   };
}
export function getVersionDetails(versionNo) {
  return {
    type: types.GET_VERSION_NUMBER,
    promise: (client) => client.get(`/getVersion?userType=Trd`)
   };
}
export function getAllFixingEvents() {
  return {
    type: types.GET_FIXING_EVENTS,
    promise: (client) => client.get(`/GetAllFixingDetails?userType=trader`)
   };
}

export function getValidFixingEvents(fd) {
  //var fd = moment(new Date()).utc().format("YYYY/MM/DD")
  return {
    type: types.GET_VALID_FIXINGORDERS,
      promise: (client) => client.get(`/GetValidFixingDetails?userType=trader&fixingDate=${fd}`)
   };
}

export function setApiFlag(flag){
  return {
    type: types.CHART_API_FLAG,
     flag,
   };
}
export function getStockCodeList(){
  return{
    type: types.LOAD_STKCODELIST,
    promise: (client) => client.get('/getStockCodeList')
  };
}
export function closedFixModal(flag,keyValue){
  return {
    type: types.CLOSE_FIX_MODAL,
     flag,
     keyValue
   };
}
export function handleFixingModal(FIXPopup) {
  return {
    type: types.HANDLE_FIX_MODAL,
    FIXPopup
  };
}
export function loadBiometricDevice(){
  const user = JSON.parse(localStorage.getItem('user'));
  const trdId =  user.UID;
  return{
    type: types.LOAD_BIOMETRIC_DEVICE,
    promise: (client) => client.get(`/getRegisteredDevices?&isTrader=${'true'}&userId=${trdId}&token_ID=${''}`)
  };
}
export function deregisterDevice(tokenId,deviceType) {
  const user = JSON.parse(localStorage.getItem('user'));
  const platform = localStorage.getItem('platform');
  return {
    type: types.LOAD_BIOMETRIC_DRESGISTER_DEVICE, 
    promise: (client) => client.post('/deregisterAppToken', {
      data: {
        userId:user.UID,
        tokenId:tokenId,
        location:user.location,
        platform: platform,
        deviceType:deviceType,
        isTrader: true
      }
    }),
   };
}

export function isAllApiLoaded(flag) {
  return {
    type: types.IS_INITIAL_API_LOADED,
    flag
  };
}
